import { render } from "./NoteCard.vue?vue&type=template&id=544d08c3"
import script from "./NoteCard.vue?vue&type=script&lang=js"
export * from "./NoteCard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/star-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__